<script lang="ts" setup>
import { $fetch } from '@/home/plugins/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { data: journalism } = useAsyncData<any[], Record<string, any>>(
  'home:journalism',
  () => $fetch('/news/v1/list', { data: { limit: 3 } }),
  {
    default: () => [],
    transform: (data) => data?.newsVOList ?? [],
  },
);
</script>

<template>
  <section class="page-home-journalism">
    <div class="journalism-container mx-auto max-w-1200 py-100">
      <div class="flex items-center justify-between">
        <h2 class="relative m-0 text-40 text-#292D33 font-600 leading-56 after:absolute after:bottom--16 after:left-0 after:right-0 after:h-4 after:bg-#1281FF after:content-empty">
          最新消息
        </h2>
        <RouterLink to="/journalism" class="flex-y-center flex-shrink-0 gap-x-8 text-16 text-#1281FF font-500 no-underline">
          <span>所有新闻</span>
          <span class="i-home-icons:arrow-right-2 block size-24"></span>
        </RouterLink>
      </div>

      <div class="mt-48px flex gap-x-30">
        <div class="journalism-card w-380 flex flex-wrap" v-for="item in journalism" :key="item.id">
          <RouterLink :to="`/journalism/detail/${item.id}`" class="block w-full no-underline">
            <img :data-src="item.cover" class="lazyload block h-200 w-full rounded-6 object-cover" :alt="item.title">

            <div class="mt-20 flex flex-col gap-y-12">
              <small class="block text-14 text-#9497A1 font-400 leading-24">
                {{ item.releaseTime }}
              </small>
              <h3 class="line-clamp-2 m-0 h-[calc(33px*2)] break-anywhere text-22 text-#292D33 font-600 leading-33" :title="item.title">
                {{ item.title }}
              </h3>
              <p class="line-clamp-2 m-0 h-[calc(28px*2)] break-anywhere text-16 text-#9497A1 font-400 leading-28" :title="item.intro">
                {{ item.intro }}
              </p>
              <div class="flex-y-center gap-x-4 text-14 text-#185CFF font-600 leading-24">
                <span>前往查看</span>
                <span class="i-home-icons:arrow-right-2 block size-20"></span>
              </div>
            </div>
          </RouterLink>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
